import React from 'react'
import { Outlet } from 'react-router-dom'

function MainClient() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainClient
